export type QualityLevel = 'low' | 'medium' | 'high';

export interface Quality {
  level: QualityLevel;
  /** Strop pro devicePixelRatio. */
  pixelRatio: number;
  /** Rozlišení stínové mapy, 0 = bez stínů. */
  shadows: number;
  bloom: boolean;
  smaa: boolean;
  /** Voda s odlesky (další průchod vykreslení). */
  water: boolean;
  /** Obloha se shaderem rozptylu světla. */
  sky: boolean;
  /** Kolik částic efektů nejvýš vykreslit. */
  maxParticles: number;
}

export const QUALITY: Record<QualityLevel, Quality> = {
  low: { level: 'low', pixelRatio: 1, shadows: 0, bloom: false, smaa: false, water: false, sky: false, maxParticles: 800 },
  medium: { level: 'medium', pixelRatio: 1.5, shadows: 1024, bloom: true, smaa: true, water: false, sky: true, maxParticles: 2000 },
  high: { level: 'high', pixelRatio: 2, shadows: 2048, bloom: true, smaa: true, water: true, sky: true, maxParticles: 4000 },
};

export const QUALITY_LABEL: Record<QualityLevel, string> = { low: 'Nízká', medium: 'Střední', high: 'Vysoká' };
export const QUALITY_ORDER: QualityLevel[] = ['low', 'medium', 'high'];

const KEY = 'tanky.quality3d';

/** Uložená volba, jinak podle zařízení (dotykové = střední). */
export function loadQuality(): QualityLevel {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'low' || v === 'medium' || v === 'high') return v;
  } catch {
    /* úložiště nedostupné */
  }
  return matchMedia('(pointer: coarse)').matches ? 'medium' : 'high';
}

export function saveQuality(level: QualityLevel) {
  try {
    localStorage.setItem(KEY, level);
  } catch {
    /* nevadí */
  }
}

/**
 * Hlídá snímkovou frekvenci: když průměr klesne pod `minFps` na `window` sekund,
 * ohlásí, že je čas snížit kvalitu.
 */
export class FpsGuard {
  private acc = 0;
  private frames = 0;
  private slowFor = 0;

  constructor(
    private minFps = 28,
    private window = 3,
  ) {}

  /** Vrací true, když je výkon dlouhodobě slabý. */
  tick(dt: number): boolean {
    // Skrytá karta, přepnutí okna apod. – nepočítat
    if (dt <= 0 || dt > 0.5) return false;
    this.acc += dt;
    this.frames++;
    if (this.acc < 0.5) return false;
    const fps = this.frames / this.acc;
    this.slowFor = fps < this.minFps ? this.slowFor + this.acc : 0;
    this.acc = 0;
    this.frames = 0;
    if (this.slowFor >= this.window) {
      this.slowFor = 0;
      return true;
    }
    return false;
  }
}
